import { IsNotEmpty, IsString } from 'class-validator';

export class PagamentoConectarBoletoDto {
  @IsString()
  @IsNotEmpty()
  boletoId: string;
}
